<h2 mat-dialog-title>Select Date Range</h2>

<mat-dialog-content class="mat-typography">
  <app-mat-datetime-input [(ngModel)]="startDate" label="Start Date"></app-mat-datetime-input>
  <app-mat-datetime-input [(ngModel)]="endDate" label="End Date"></app-mat-datetime-input>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
  <button mat-button (click)="closeSendConfirmPopup('close')">Close</button>
</mat-dialog-actions>
